export default "__VITE_PUBLIC_ASSET__de8b95d9__"